/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsModule
 */

import { IIpAddr, IVipRuntimeDetail } from 'generated-types';
import { IVsVipData } from './factories/vs-vip.item.factory';

/**
 * Enumerations constant holding types of operational states. We have 18 OperationalStates
 * like 'OPER_RESOURCES', 'OPER_UNUSED', 'OPER_DISABLED' etc. These operational states are mainly
 * categorised into 3 types like 'OPER_UP', 'OPER_DOWN' and 'OPER_PENDING'.
 */
export enum OperStateType {
    OPER_UP = 'up',
    OPER_DOWN = 'down',
    OPER_PENDING = 'pending',
}

export interface IExtendedVipRuntimeDetail extends IVipRuntimeDetail {
    ip_address?: IIpAddr;
    ip6_address?: IIpAddr;
    operStateType?: OperStateType;
    floating_ip?: IIpAddr;
    floating_ip6?: IIpAddr;
    vsVip?: IVsVipData;
}
